export const DEFAULT_PAYSLIP_TYPE = "standard";

export function normalizePayslipType(payslipType) {
  return typeof payslipType === "string" &&
    payslipType.trim().toLowerCase() === "carbonized"
    ? "carbonized"
    : DEFAULT_PAYSLIP_TYPE;
}

export function normalizePayslipEntry(entry) {
  if (typeof entry === "string") {
    const pathSegments = entry.split(/[\\/]/).filter(Boolean);

    return {
      payOutDate: pathSegments[pathSegments.length - 1] || "",
      payslipType: DEFAULT_PAYSLIP_TYPE,
    };
  }

  const payslip = entry || {};

  return {
    ...payslip,
    payslipType: normalizePayslipType(payslip.payslipType),
  };
}

export function createAuthenticatedPdfSource(url) {
  const accessToken = localStorage.getItem("accessToken");
  const source = { url };

  if (accessToken) {
    source.httpHeaders = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  return source;
}

export function getPdfSourceUrl(source) {
  return typeof source === "string" ? source : source && source.url;
}
